import { inject, Signal } from '@angular/core';
import { FeatureToggleManagerService } from '@lentau/core/feature-toggle';
import { GrowthBookValue } from '@lentau/core/growth-book/shared';

const EXPERIMENT_NAME: string = 'exp_pwa_checkout';

export const pwaB2cCheckoutExperiment = (): Signal<boolean> => {
  const featureToggleManagerService: FeatureToggleManagerService = inject(FeatureToggleManagerService);

  return featureToggleManagerService.checkParam(EXPERIMENT_NAME, GrowthBookValue.Test);
};
